import { FileType } from '@uturn/api/v1';
import { z } from '@uturn/portal/zod';
import { MAX_DESCRIPTION_CHARACTERS } from '@uturn/portal/components/file-dropzone';

export const addDocumentSchema = z.object({
	fileType: z.nativeEnum(FileType),
	description: z.string().max(MAX_DESCRIPTION_CHARACTERS).optional(),
	fileName: z.string().min(1),
	file: z.instanceof(File),
});

export type AddDocumentFormValues = z.infer<typeof addDocumentSchema>;
